import { lineSpacingModals } from ".//consts";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { TOOLBAR_BUTTON } from "./data-hooks";
import LineSpacingIcon from "./icons/toolbars-v3/LineSpacingIcon";
import LineSpacingPanelComponent from "./LineSpacingPanelComponent";
const getTextButtons = () => {
  return [
    {
      id: "LINE_SPACING",
      type: "modal",
      presentation: {
        dataHook: TOOLBAR_BUTTON,
        tooltip: "LineSpacingButton_Tooltip",
        icon: LineSpacingIcon
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED
      },
      modal: {
        id: lineSpacingModals.spacingOptions,
        Component: LineSpacingPanelComponent
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
